import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from '@src/app/providers/providers';

@Injectable()
export class UrlService {
  public host: string = inject(ENVIRONMENT).hostUrl;
  public auth = `${this.host}/auth`;
  public logout = `${this.auth}/logout`;
  //public offers = `${this.host}/offers`;
}
